import { publicAssetUrl } from '@wilkins-software/redwood-utils';

import {
  createExtrudedSvgThreeScene,
  type ExtrudedSvgThreeSceneHandle,
} from './extruded-svg-three-scene';

const YOU_POWER_PROJECT_MARK_URL = publicAssetUrl(
  'images/you-power-project-mark.svg',
);

export type YouPowerProjectThreeSceneHandle = ExtrudedSvgThreeSceneHandle;

/**
 * You Power Project showcase mark: extruded rocket/lightbulb SVG with yellow
 * accent lighting. Thin wrapper around the shared enamel-pin scene factory.
 */
export async function createYouPowerProjectThreeScene(
  container: HTMLElement,
): Promise<YouPowerProjectThreeSceneHandle | null> {
  return createExtrudedSvgThreeScene(container, {
    svgUrl: YOU_POWER_PROJECT_MARK_URL,
    svgViewBoxHeight: 340,
    logoWorldHeight: 5.0,
    minShapeAreaSvgUnits: 40,
    rimLightColor: 0xf5c518,
    topRimLightColor: 0xfff3a8,
    sideKickerColor: 0xffe08a,
    hemisphereSkyColor: 0xfffbeb,
    hemisphereGroundColor: 0x111111,
  });
}
